const localeMap: Record<string, string> = {
  'uz-Latn': 'uz-Latn-UZ',
  'uz-Cyrl': 'uz-Cyrl-UZ',
  ru: 'ru-RU',
  en: 'en-US',
};

export function formatUZS(tiyin: number, lang = 'uz-Latn'): string {
  const sums = tiyin / 100;
  const locale = localeMap[lang] ?? 'uz-Latn-UZ';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'UZS',
      maximumFractionDigits: 0,
    }).format(sums);
  } catch {
    return `${Math.round(sums).toLocaleString()} UZS`;
  }
}

export function tiyinToSum(tiyin: number): number {
  return tiyin / 100;
}
